/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { growthHistoryControllerCreate } from '../fn/growth-history/growth-history-controller-create';
import { GrowthHistoryControllerCreate$Params } from '../fn/growth-history/growth-history-controller-create';
import { growthHistoryControllerDelete } from '../fn/growth-history/growth-history-controller-delete';
import { GrowthHistoryControllerDelete$Params } from '../fn/growth-history/growth-history-controller-delete';
import { growthHistoryControllerFindById } from '../fn/growth-history/growth-history-controller-find-by-id';
import { GrowthHistoryControllerFindById$Params } from '../fn/growth-history/growth-history-controller-find-by-id';
import { growthHistoryControllerSearch } from '../fn/growth-history/growth-history-controller-search';
import { GrowthHistoryControllerSearch$Params } from '../fn/growth-history/growth-history-controller-search';
import { growthHistoryControllerTogglePublic } from '../fn/growth-history/growth-history-controller-toggle-public';
import { GrowthHistoryControllerTogglePublic$Params } from '../fn/growth-history/growth-history-controller-toggle-public';
import { growthHistoryControllerUpdate } from '../fn/growth-history/growth-history-controller-update';
import { GrowthHistoryControllerUpdate$Params } from '../fn/growth-history/growth-history-controller-update';
import { GrowthHistoryDto } from '../models/growth-history-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class GrowthHistoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `growthHistoryControllerSearch()` */
  static readonly GrowthHistoryControllerSearchPath = '/api/growth-history';

  /**
   * 성장 이력 목록 조회.
   *
   * 돼지의 성장 이력을 페이지네이션으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthHistoryControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthHistoryControllerSearch$Response(params: GrowthHistoryControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<GrowthHistoryDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = growthHistoryControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 성장 이력 목록 조회.
   *
   * 돼지의 성장 이력을 페이지네이션으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthHistoryControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthHistoryControllerSearch(params: GrowthHistoryControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<GrowthHistoryDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.growthHistoryControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<GrowthHistoryDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<GrowthHistoryDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `growthHistoryControllerCreate()` */
  static readonly GrowthHistoryControllerCreatePath = '/api/growth-history';

  /**
   * 성장 이력 등록.
   *
   * 새로운 성장 이력을 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthHistoryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthHistoryControllerCreate$Response(params: GrowthHistoryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthHistoryDto>> {
    const obs = growthHistoryControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 성장 이력 등록.
   *
   * 새로운 성장 이력을 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthHistoryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthHistoryControllerCreate(params: GrowthHistoryControllerCreate$Params, context?: HttpContext): Observable<GrowthHistoryDto> {
    const resp = this.growthHistoryControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GrowthHistoryDto>): GrowthHistoryDto => r.body)
    );
  }

  /** Path part for operation `growthHistoryControllerFindById()` */
  static readonly GrowthHistoryControllerFindByIdPath = '/api/growth-history/{id}';

  /**
   * 성장 이력 상세 조회.
   *
   * 성장 이력을 ID로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthHistoryControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthHistoryControllerFindById$Response(params: GrowthHistoryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthHistoryDto>> {
    const obs = growthHistoryControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 성장 이력 상세 조회.
   *
   * 성장 이력을 ID로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthHistoryControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthHistoryControllerFindById(params: GrowthHistoryControllerFindById$Params, context?: HttpContext): Observable<GrowthHistoryDto> {
    const resp = this.growthHistoryControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GrowthHistoryDto>): GrowthHistoryDto => r.body)
    );
  }

  /** Path part for operation `growthHistoryControllerDelete()` */
  static readonly GrowthHistoryControllerDeletePath = '/api/growth-history/{id}';

  /**
   * 성장 이력 삭제.
   *
   * 성장 이력을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthHistoryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthHistoryControllerDelete$Response(params: GrowthHistoryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthHistoryDto>> {
    const obs = growthHistoryControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 성장 이력 삭제.
   *
   * 성장 이력을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthHistoryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthHistoryControllerDelete(params: GrowthHistoryControllerDelete$Params, context?: HttpContext): Observable<GrowthHistoryDto> {
    const resp = this.growthHistoryControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GrowthHistoryDto>): GrowthHistoryDto => r.body)
    );
  }

  /** Path part for operation `growthHistoryControllerUpdate()` */
  static readonly GrowthHistoryControllerUpdatePath = '/api/growth-history/{id}';

  /**
   * 성장 이력 수정.
   *
   * 성장 이력을 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthHistoryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthHistoryControllerUpdate$Response(params: GrowthHistoryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthHistoryDto>> {
    const obs = growthHistoryControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 성장 이력 수정.
   *
   * 성장 이력을 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthHistoryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthHistoryControllerUpdate(params: GrowthHistoryControllerUpdate$Params, context?: HttpContext): Observable<GrowthHistoryDto> {
    const resp = this.growthHistoryControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GrowthHistoryDto>): GrowthHistoryDto => r.body)
    );
  }

  /** Path part for operation `growthHistoryControllerTogglePublic()` */
  static readonly GrowthHistoryControllerTogglePublicPath = '/api/growth-history/{id}/toggle-public';

  /**
   * 공개 여부 토글.
   *
   * 성장 이력의 공개 여부를 토글합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthHistoryControllerTogglePublic()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthHistoryControllerTogglePublic$Response(params: GrowthHistoryControllerTogglePublic$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = growthHistoryControllerTogglePublic(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공개 여부 토글.
   *
   * 성장 이력의 공개 여부를 토글합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthHistoryControllerTogglePublic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthHistoryControllerTogglePublic(params: GrowthHistoryControllerTogglePublic$Params, context?: HttpContext): Observable<void> {
    const resp = this.growthHistoryControllerTogglePublic$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
